<div class="flex gap-x-3 py-4 border-b border-b-neutral-300 px-4">
  <ngx-skeleton-loader
    [theme]="{
      'border-radius': '100%',
      height: '70px',
      width: '70px',
    }"
  ></ngx-skeleton-loader>

  <div class="flex-1">
    <ngx-skeleton-loader [theme]="{ height: '24px', margin: 0 }" appearance="line"></ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="{ height: '16x', margin: 0 }" appearance="line"></ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="{ height: '16px', margin: 0 }" appearance="line"></ngx-skeleton-loader>
  </div>
</div>
